import React from 'react'
import { Box, Divider, Stack } from '@mui/material'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import format from 'date-fns/format'
import { RefundRequestsType } from 'types/api/faber/payment.type'
function FaberViewMoreInformation({
  paymentRow
}: {
  paymentRow: RefundRequestsType
}) {
  return (
    <>
      <Box>
        <Stack
          direction='row'
          alignItems='center'
          sx={{ backgroundColor: '#ebedfb', mt: 1, px: 2 }}
        >
          <NormalText isBold sx={{ fontSize: '1em' }}>
            Payment ID:
          </NormalText>
          <TextColorFontBody>{paymentRow.refundPaymentId}</TextColorFontBody>
        </Stack>
        <Box sx={{ p: 1 }}>
          <Box sx={{ mx: 1, mb: 1 }}>
            <Box>
              <NormalText isBold>Refund Reason:</NormalText>
              <NormalText sx={{ fontSize: '0.8em' }}>
                {paymentRow.refundReason}
              </NormalText>
            </Box>
            <Divider sx={{ width: '100%' }} />

            <Divider sx={{ width: '100%' }} />
            <Box>
              <NormalText isBold>Zendesk Ticket Number:</NormalText>
              <NormalText sx={{ fontSize: '0.8em' }}>
                {paymentRow.ticketId}
              </NormalText>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <Box>
              <NormalText isBold>Cancel Subscription:</NormalText>
              <NormalText sx={{ fontSize: '0.8em' }}>
                {paymentRow.terminateSub ? 'Yes' : 'No'}
              </NormalText>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <Box>
              <NormalText isBold>Requestor Email:</NormalText>
              <NormalText sx={{ fontSize: '0.8em' }}>
                {paymentRow.createdBy}
              </NormalText>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <Box>
              <NormalText isBold>Refund Request Created On:</NormalText>
              <NormalText sx={{ fontSize: '0.8em' }}>
                {format(new Date(paymentRow.CreatedAt), 'dd MMM yyyy HH:mm')}
              </NormalText>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <Box>
              <NormalText isBold>Refund Request Updated On:</NormalText>
              <NormalText sx={{ fontSize: '0.8em' }}>
                {format(new Date(paymentRow.UpdatedAt), 'dd MMM yyyy HH:mm')}
              </NormalText>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default FaberViewMoreInformation
